<template>
  <common-default-layout :spring-desktop-size="100" is-aw-spring :small-header="smallHeader">
    <template v-if="$slots.categoryMenu?.()?.[0]?.children?.length" #categoryMenu />
    <template #content="{ defaultLayoutClasses }">
      <slot name="content" :default-layout-classes="defaultLayoutClasses">
        <div :class="[defaultLayoutClasses.container]">
          <component :is="springComponent" v-bind="springAttributes">
            <slot />
          </component>
        </div>
      </slot>
    </template>
    <template #before-footer>
      <aw-catalog-footer-block />
    </template>
    <template #modal>
      <aw-shop-modals />
    </template>
  </common-default-layout>
</template>

<script>
  import { mapState } from 'pinia';
  import CommonDefaultLayout from '~~/common/layouts/default';

  import { useUrlResourceStore } from '~~/common/stores/urlResource';
  import { useCategoryStore } from '~~/common/stores/category';
  import { LvSpring } from '~~/common/components/loginet-vue-shop/index';
  import AwSpring from '~~/common/components/AwSpring';
  import pageTypeMixin from '~~/common/mixins/pageTypeMixin.js';
  import AwShopModals from '~~/shop/app/components/Common/Modals/AwShopModals.vue';
  import { defineLazyHydrationComponent } from '#app/composables/lazy-hydration';

  const AwCatalogFooterBlock = defineLazyHydrationComponent('visible', () => import('~~/shop/app/components/AwCatalogFooterBlock.vue'));

  export default {
    name: 'DynamicContentLayout',
    components: {
      AwShopModals,
      AwCatalogFooterBlock,
      CommonDefaultLayout,
      AwSpring,
      LvSpring,
    },
    mixins: [pageTypeMixin],
    props: {
      springSize: {
        type: [String, Boolean],
        default: null,
      },
      smallHeader: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState(useCategoryStore, {
        getCategoryFromTree: state => state.getCategoryFromTree,
      }),
      ...mapState(useUrlResourceStore, {
        calculatedSpringDesktopSize (state) {
          const { resourceType } = state.data;

          const isContentOrCatalog = resourceType === 'cms_content' || resourceType === 'catalog';
          if (isContentOrCatalog || this.isCareerPage) {
            return 100;
          }
          if (this.isSdsPage) {
            return 10;
          }
          return null;
        },
        resourceType: state => state.data.resourceType,
      }),
      calculatedSpringSize () {
        if (this.springSize) {
          return this.springSize;
        }
        if (this.calculatedSpringDesktopSize) {
          return null;
        }
        return 'md';
      },
      springComponent () {
        const containsProductListPage = this.isProductListPage || this.isSearchPage || this.isBoutique || this.isShortList || this.isLoyaltyOffer || this.isPreviouslyOrderedProducts;
        return !this.calculatedSpringSize || containsProductListPage || this.resourceType === 'catalog' || this.isFaqPage || this.isProductDetailsPage || this.isCareerPage || this.isSdsPage ? AwSpring : LvSpring;
      },
      springAttributes () {
        return !this.calculatedSpringSize
          ? {
            desktopSize: this.calculatedSpringDesktopSize,
          }
          : {
            size: this.calculatedSpringSize,
          }
        ;
      },
    },
  };
</script>

<style module lang="scss" rel="stylesheet/scss">
.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: $color-seashell;
}

.container {
  flex: 1;
  margin-top: 60px;
  padding-bottom: 24px;

  @include md(max) {
    margin-top: 24px;
    padding-bottom: 16px;
  }
}

.overflowHidden {
  overflow: hidden;
}

.sticky {
  position: sticky;
  z-index: 7;
  top: 0;
}

.headerSearch {
  margin: 16px;

  &Wrapper {
    position: relative;
    width: 100%;
    max-width: 288px;
    margin: auto;
  }

  &Bar {
    width: 100%;
    max-width: 288px;
    height: 56px;
    padding: 8px 56px 8px 16px;
    border: 1px solid $color-alto;
    border-radius: 8px;
    background: $color-white;
  }

  &Icon {
    position: absolute;
    top: 16px;
    right: 16px;
    bottom: 16px;
  }
}
</style>
